
import React, { FC, useState } from 'react';
import setTheme from '@lib/theme';
import {
    Card,
    Column,
    Row,
    Spacer,
    Text
} from '@components/1-atoms';
import * as utils from '@lib/utils';
import _ from 'underscore';
import Filter from '@assets/icons/filter';



type Props = { navigation: any; startDate: Date, endDate: Date}

const theme = setTheme('light');

const IncomeStatamentHeader: FC<Props> = ({ navigation, startDate, endDate, ...props }) => {

    const d1:string = utils.formatDate(startDate, "MMM d, yyyy'");
    const d2:string = utils.formatDate(endDate, "MMM d, yyyy'");
    
    const dateRange = `From ${d1} to ${d2}`;
    
    return (
    <Card>
        <Row>
            <Column>
                <Text large>Current month to date</Text>
                <Spacer h={2} />
                <Text color={"#7E7E7E"} small>{dateRange}</Text>
            </Column>
            <Spacer w={1} />

            {/* <Filter /> */}
        </Row>
    </Card>
    );
};

export default IncomeStatamentHeader;